import React from "react";
import PropTypes from "prop-types";
import {Doughnut} from "react-chartjs-2";

const ProjectChart = ({ chartData }) => (
	<div className="project-card project-charts">
		<h3 className="card-title">Project financial informations</h3>
		<Doughnut data={{
			labels: (chartData && chartData.labels) ? chartData.labels : [],
			datasets: [{
				backgroundColor: ["#2ab27b", "#bf3b29"],
				data: (chartData && chartData.datasets) ? chartData.datasets : []
			}]
		}} />
	</div>
);

ProjectChart.propTypes = {
	chartData: PropTypes.shape({
		labels: PropTypes.array,
		datasets: PropTypes.array
	}).isRequired
};

export default ProjectChart;



// WEBPACK FOOTER //
// ./src/components/pages/projects/ProjectChart.js